import { ssr } from '@atlassian/jira-browser-metrics/src/bm3-init/ssr/index.tsx';

/*
 * This function only supports detecting sucess for Modern SSR
 */
export function didSSRSucceed(): boolean {
	const traceData = globalThis.window?.SPA_STATE?.['ssr/detail_request_trace']?.data;
	const ssrDetails = globalThis?.window?.SSR_DETAILS;
	if (!traceData || !ssrDetails) {
		return false;
	}
	const prefetchTimedOut = Object.values(
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		traceData as {
			[key: string]: {
				startTime?: number;
				duration?: number;
				failureReason?: string;
			};
		},
	).some((x) => x.failureReason === 'timeout');
	return (
		!prefetchTimedOut &&
		ssr.getFeatureFlags()?.ssrViaBifrost &&
		globalThis.window?.SPA_STATE?.['ssr/render_status'] !== 'failed' &&
		ssrDetails?.completed
	);
}
